import request from '@/utils/request';
import { trackWebpageFormSubmitted } from '@/lib/analytics/webpageAnalytics';

export const WEBPAGE = 'WEBPAGE';
export const PUBLIC_ERROR = 'PUBLIC_ERROR';

export const health = () => async () => {
  await request({ path: `/v1/health` });
};

export const fetchWebpageInfo = ({ ctx, domain, rootDomain }) => {
  return async dispatch => {
    try {
      const response = await request({
        path: `/v1/users/${domain}/webpage`,
        headers: {
          'X-Forwarded-Host': rootDomain,
          // Server-only shared secret (NOT NEXT_PUBLIC_) — runs during SSR only,
          // so it never reaches the browser. Gates the public webpage endpoint.
          'X-Internal-Token': process.env.WEBPAGE_INTERNAL_TOKEN
        }
      });

      return dispatch({
        payload: response,
        type: WEBPAGE
      });
    } catch (e) {
      return dispatch({
        type: PUBLIC_ERROR
      });
    }
  };
};

export const webpageContactRequest =
  ({ domain, body }) =>
  async () => {
    const response = await request({
      path: `/v1/contacts/webpage/${domain}`,
      method: 'POST',
      body
    });
    trackWebpageFormSubmitted();
    return response;
  };

export const applyToJobPostingRequest =
  ({ domain, formDataBody }) =>
  async () => {
    const response = await request({
      path: `/v1/contacts/webpage/${domain}`,
      method: 'POST',
      formData: true,
      formDataBody
    });
    trackWebpageFormSubmitted();
    return response;
  };

export const fetchSetting = id => async () =>
  await request({
    path: `/v1/settings/${id}`
  });

export const submitSoaRequest = (body, domain_name) => async () =>
  await request({
    path: `/v1/soa_requests/${body.id}/submit?domain_name=${domain_name}`,
    method: 'POST',
    body
  });

export const viewSoaRequest = (id, domain_name) => async () =>
  await request({
    path: `/v1/soa_requests/${id}/view?domain_name=${domain_name}`
  });
